"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Header = _interopRequireDefault(require("../../../Card/Header"));

require("./style.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    dialog: {
      background: "none",
      boxShadow: "none",
      maxWidth: "60vw"
    }
  };
});

var Transition = _react.default.forwardRef(function Transition(props, ref) {
  return _react.default.createElement(_core.Slide, _extends({
    direction: "up",
    ref: ref
  }, props));
});
/**
 * Gallery image formatting component
 */


function GalleryImage(props) {
  var className = props.className,
      color = props.color,
      content = props.content,
      label = props.label,
      noImage = props.noImage,
      style = props.style,
      src = props.src;
  var classes = useStyles();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var handleCloseDialog = function handleCloseDialog() {
    setActive(false);
  };

  var handleOpenDialog = function handleOpenDialog() {
    setActive(true);
  };

  var renderDialog = function renderDialog() {
    var dialogClasses = "story-gallery-dialog";
    if (noImage) dialogClasses += ' no-image-layout';
    return _react.default.createElement(_core.Dialog, {
      className: dialogClasses,
      open: active,
      TransitionComponent: Transition,
      keepMounted: true,
      onClose: handleCloseDialog,
      classes: {
        paper: classes.dialog
      }
    }, noImage ? _react.default.createElement("div", {
      className: "story-gallery-dialog-body no-image-layout",
      style: {
        backgroundImage: "url(".concat(src, ")")
      }
    }, _react.default.createElement("div", {
      className: "story-gallery-dialog-body__inner"
    }, _react.default.createElement(_Header.default, {
      text: label
    }), _react.default.createElement(_core.Divider, null), _react.default.createElement("div", {
      className: "lightbox-content"
    }, content)), _react.default.createElement("div", {
      className: "close-btn",
      onClick: handleCloseDialog
    }, "X")) : _react.default.createElement("div", {
      className: "story-gallery-dialog-body"
    }, _react.default.createElement("img", {
      className: "dialog-image",
      src: src
    }), _react.default.createElement("div", {
      className: "story-gallery-dialog-body__content"
    }, _react.default.createElement(_Header.default, {
      text: label
    }), _react.default.createElement(_core.Divider, null), _react.default.createElement("div", {
      className: "lightbox-content"
    }, content)), _react.default.createElement("div", {
      className: "close-btn",
      onClick: handleCloseDialog
    }, "X")));
  };

  var contentStyle = {
    color: color.text,
    textShadow: "3px 2px 0px ".concat(color.background)
  };

  var imageStyle = _objectSpread({}, style, {
    backgroundImage: "url(".concat(src, ")")
  });

  var containerClasses = className + " story-gallery-image-container";
  if (noImage) containerClasses += ' no-image-layout';
  return _react.default.createElement("div", {
    className: containerClasses
  }, _react.default.createElement("div", {
    style: imageStyle,
    className: "story-gallery-image",
    onClick: handleOpenDialog
  }, _react.default.createElement("div", {
    className: "story-gallery-image__contents",
    style: contentStyle
  }, _react.default.createElement("div", {
    className: "story-gallery-image__contents-label"
  }, label))), renderDialog());
}

;
GalleryImage.propTypes = {
  /** Determines the background and text color of the `Image` label. */
  color: _propTypes.default.shape({
    background: _propTypes.default.string,
    text: _propTypes.default.string
  }),

  /** Content to go underneath the title in a detail page */
  content: _propTypes.default.any,

  /** Determines the main text of the `Image`. */
  label: _propTypes.default.string,

  /** Determines if the layout should emphasize the text or the image. */
  noImage: _propTypes.default.bool,

  /** The destination URL of the `Image` */
  src: _propTypes.default.string.isRequired
};
GalleryImage.defaultProps = {
  color: {
    background: "#ffc7ed9e",
    text: '#000'
  },
  noImage: false,
  style: {}
};
var _default = GalleryImage;
exports.default = _default;